import React from 'react';
import { capitalize } from '../../util/helpers/Strings';

function withEditMode(propKey) {
  return Component => (
    class Container extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          localState: this.props[propKey],
        };
      }

      UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ localState: nextProps[propKey] });
      }

      editMember = (key, value) => {
        this.setState(state => (
          { localState: state.localState.set(key, value) }
        ));
      }

      // Returns a function to apply to a an event listener on
      // a form field to use to update a member
      editFromFormField = (key, extractor = e => e.target.value) => (e) => {
        this.editMember(key, extractor(e));
      };

      render() {
        const newProps = {
          [`currentEdited${capitalize(propKey)}`]: this.state.localState,
          editMember: this.editMember,
          editFromFormField: this.editFromFormField,
        };

        return <Component {...this.props} {...newProps} />;
      }
    }
  );
}

export default withEditMode;
